<template>
    <div>
        <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NkmEmoU.png" width="100%" />

        <div class="middle">
            <div class="qrCode">
                <vue-qr :margin="0" :text="jobInfo.jobQrCode" :logoScale="0.25"
                        v-if="jobInfo.jobQrCode" :size="185" :callback="qrCallback"></vue-qr>
            </div>
            <van-button round size="small" type="warning" @click="changeTaskShare()" style="width:10rem;">
                点击换码
            </van-button>
        </div>
    </div>
</template>

<script>
    import vueQr from 'vue-qr';
    import mainAPI from '@/api/main';

    export default {
        components: {
            vueQr
        },
        data() {
            return {
                query: {
                    jobId: this.$route.query.jobId,
                    traderId: this.$route.query.traderId,
                    mid: this.$route.query.mid,
                },
                jobInfo: {},
            }
        },
        methods: {
            qrCallback(url, id) {
            },
            changeTaskShare() {
                mainAPI.changeOrderByTraderId(this.query.jobId, this.query.traderId).then((result) => {
                    this.jobInfo = result.data;
                })
            },
        },
        created() {
            this.changeTaskShare();
        },
        mounted() {
        }
    }

</script>

<style lang="scss" scoped>

    .middle {
        background-color: #fff;
        margin: 1rem 8%;
        border-radius: 1rem;
        padding: 1rem;
        text-align: center;
    }

    .qrCode {
        margin: 1rem auto;
        width: 15.42rem;
        height: 15.42rem;
        background: white;

        img {
            width: 100%;
            height: 100%;
        }
    }

</style>
